import { FMS_PAGE, ThreeD_PAGE, WALK_AROUND, CABIN, BASIC_PAGE } from "../components/constants/pageTypes";
import { isEnvironment } from "./environment";

const DEV_ONLY_PAGE_TYPES = new Set([FMS_PAGE, ThreeD_PAGE, WALK_AROUND, CABIN]);

export interface PageLike {
  pagePlayerType: string;
  pageManifest?: {
    basePageType?: string;
    [key: string]: unknown;
  };
}

/**
 * checks if a page type is restricted to dev environments only
 * includes FMS, Cockpit, Walkaround, Cabin, and non-freeForm basic pages
 */
export function isDevOnlyPage(page: PageLike): boolean {
  if (!page) return false;

  if (DEV_ONLY_PAGE_TYPES.has(page.pagePlayerType)) {
    return true;
  }

  // non-freeForm basic pages are dev-only too
  if (page.pagePlayerType === BASIC_PAGE && page.pageManifest?.basePageType !== "freeForm") {
    return true;
  }

  return false;
}

/**
 * checks if a page can be used (created/copied) in the current environment
 */
export function canUsePage(page: PageLike): boolean {
  return !isDevOnlyPage(page) || isEnvironment("development", "local");
}
